import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../pages/Home.vue";
import Courses from "../pages/Courses.vue";
import CoursesSimulate from "../pages/CoursesSimulate.vue";
import Branches from "../pages/Branches.vue";
import BranchesSimulate from "../pages/BranchesSimulate.vue";
import PreRegistration from "../pages/PreRegistration.vue";
import MyDiary from "../pages/MyMailings.vue";
import MyMailings from "../pages/MyDiary.vue";

import Classes from "../pages/Classes.vue";
import Mailing from "../pages/Mailing.vue";
import ImportedMailing from "../pages/ImportedMailing.vue";
import Electives from "../pages/Electives.vue";
import Introductories from "../pages/Introductories.vue";
import Subjects from "../pages/Subjects.vue";
import Tax from "../pages/Tax.vue";
import TaxSimulate from "../pages/TaxSimulate.vue";
import Payment from "../pages/Payment.vue";
import PaymentSimulate from "../pages/PaymentSimulate.vue";
import YoungApprentice from "../pages/YoungApprentice.vue";
import Apprentice from "../pages/Apprentice.vue";
import AdmissionMode from "../pages/AdmissionMode.vue";
import ReviewInformation from "../pages/ReviewInformation.vue";
import FinancialResponsible from "../pages/FinancialResponsible.vue";
import ReEnrollment from "../pages/ReEnrollment.vue";
import OffersReEnrollment from "../pages/OffersReEnrollment.vue";
import ClassReEnrollment from "../pages/ClassReEnrollment.vue";
import ElectiveReEnrollment from "../pages/ElectiveReEnrollment.vue";
import SubjectsReEnrollment from "../pages/SubjectsReEnrollment.vue";
import ReEnrollmentFinancialResponsible from "../pages/ReEnrollmentFinancialResponsible.vue";
import TransfersStep1 from "@/pages/TransfersStep1";
import TransfersStep2 from "@/pages/TransfersStep2";
import TransfersResume from "@/pages/TransfersResume";
import BatchTransfer from "@/pages/BatchTransfer";
import Client from "@/pages/ClientSupplier";
import Audits from "@/pages/Audits";
import AuditStepEmancipated from "../pages/AuditStepEmancipated";
import AuditStep1A from "../pages/AuditStep1A";
import AuditStep1B from "../pages/AuditStep1B";
import AuditStep2 from "../pages/AuditStep2";
import AuditStep3 from "../pages/AuditStep3";
import AuditStep4 from "../pages/AuditStep4";
import Critical from "../pages/Critical.vue";

import {
  clearStepsInformation,
  getStepsInformation,
  isLogged
} from "../helpers/storage";
import { safeNext } from "../helpers";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/login/:ra",
      component: Home,
      meta: {
        isLogin: true,
        rule: "public"
      }
    },
    {
      path: "/login",
      component: Home,
      meta: {
        isLogin: true,
        rule: "public"
      }
    },
    {
      path: "/courses",
      component: Courses,
      meta: {
        simulatingRegister: true,
        rule: "isComercial"
      }
    },
    {
      path: "/critical",
      component: Critical,
      meta: {
        rule: "isComercial"
      }
    },
    {
      path: "/simulate/courses",
      component: CoursesSimulate,
      meta: {
        rule: "isComercial"
      }
    },
    {
      path: "/not-authorized",
      component: () => import("@/pages/NotAuthorized"),
      meta: {
        rule: "*"
      }
    },
    {
      path: "/preregistrations",
      component: PreRegistration,
      meta: {
        clearStepsInformation: true,
        rule: "isComercial"
      }
    },
    {
      path: "/young-apprentice",
      component: YoungApprentice,
      meta: {
        rule: "isLogged"
      }
    },
    {
      path: "/apprentice",
      component: Apprentice,
      meta: {
        rule: "isLogged"
      }
    },
    {
      path: "/classreenrollment",
      component: ClassReEnrollment,
      meta: {
        rule: "isStudentOrSecretary"
      }
    },
    {
      path: "/remFinancialResponsible",
      component: ReEnrollmentFinancialResponsible,
      meta: {
        rule: "isStudentOrSecretary"
      }
    },
    {
      path: "/subjectsreenrollment",
      component: SubjectsReEnrollment,
      meta: {
        rule: "isStudentOrSecretary"
      }
    },
    {
      path: "/electivereenrollment",
      component: ElectiveReEnrollment,
      meta: {
        rule: "isStudentOrSecretary"
      }
    },

    {
      path: "/mydiary",
      component: MyDiary,
      meta: {
        clearStepsInformation: true,
        rule: "isComercial"
      }
    },
    {
      path: "/myMailings",
      component: MyMailings,
      meta: {
        clearStepsInformation: true,
        rule: "isComercial"
      }
    },
    {
      path: "/branches",
      component: Branches,
      meta: {
        simulatingRegister: true,
        rule: "isComercial"
      }
    },
    {
      path: "/simulate/branches",
      component: BranchesSimulate,
      meta: {
        rule: "isComercial"
      }
    },
    {
      path: "/classes",
      component: Classes,
      meta: {
        simulatingRegister: true,
        rule: "isComercial"
      }
    },
    {
      path: "/mailing",
      component: Mailing,
      meta: {
        clearStepsInformation: true,
        rule: "isLogged"
      }
    },
    {
      path: "/reenrollment",
      component: ReEnrollment,
      meta: {
        clearStepsInformation: true,
        rule: "isStudentOrSecretary"
      }
    },
    {
      path: "/offersreenrollment",
      component: OffersReEnrollment,
      meta: {
        rule: "isStudentOrSecretary"
      }
    },

    {
      path: "/importmailing",
      component: ImportedMailing,
      meta: {
        clearStepsInformation: true,
        rule: "isComercial"
      }
    },
    {
      path: "/electives",
      component: Electives,
      meta: {
        simulatingRegister: true,
        rule: "isComercial"
      }
    },
    {
      path: "/introductories",
      component: Introductories,
      meta: {
        simulatingRegister: true,
        rule: "isComercial"
      }
    },
    {
      path: "/subjects",
      component: Subjects,
      meta: {
        simulatingRegister: true,
        rule: "isComercial"
      }
    },
    {
      path: "/tax",
      component: Tax,
      meta: {
        simulatingRegister: true,
        rule: "isComercial"
      }
    },
    {
      path: "/simulate/tax",
      component: TaxSimulate,
      meta: {
        rule: "isComercial"
      }
    },
    {
      path: "/payment",
      component: Payment,
      meta: {
        simulatingRegister: true,
        rule: "isLogged"
      }
    },
    {
      path: "/simulate/payment",
      component: PaymentSimulate,
      meta: {
        rule: "isLogged"
      }
    },
    {
      path: "/admissionMode",
      component: AdmissionMode,
      meta: {
        simulatingRegister: true,
        rule: "isComercial"
      }
    },
    {
      path: "/financialResponsible",
      component: FinancialResponsible,
      meta: {
        simulatingRegister: true,
        rule: "isComercial"
      }
    },
    {
      path: "/reviewInformation",
      component: ReviewInformation,
      meta: {
        simulatingRegister: true,
        rule: "isLogged"
      }
    },
    {
      path: "/transfers",
      component: TransfersStep1,
      meta: {
        rule: "isSecretary"
      }
    },
    {
      path: "/transfersStep2",
      component: TransfersStep2,
      meta: {
        rule: "isSecretary"
      }
    },
    {
      path: "/transfersResume",
      component: TransfersResume,
      meta: {
        rule: "isSecretary"
      }
    },
    {
      path: "/batchtransfer",
      component: BatchTransfer,
      meta: {
        rule: "isSecretary"
      }
    },
    {
      path: "/client",
      component: Client,
      meta: {
        rule: "isSecretaryFundOrOnline"
      }
    },
    {
      path: "/audits",
      component: Audits,
      meta: {
        rule: "isSecretaryOnLine"
      }
    },

    {
      path: "/audits/emancipated",
      component: AuditStepEmancipated,
      meta: {
        rule: "isSecretaryOnLine"
      }
    },

    {
      path: "/audits/1a",
      component: AuditStep1A,
      meta: {
        rule: "isSecretaryOnLine"
      }
    },
    {
      path: "/audits/1b",
      component: AuditStep1B,
      meta: {
        rule: "isSecretaryOnLine"
      }
    },
    {
      path: "/audits/2",
      component: AuditStep2,
      meta: {
        rule: "isSecretaryOnLine"
      }
    },

    {
      path: "/audits/3",
      component: AuditStep3,
      meta: {
        rule: "isSecretaryOnLine"
      }
    },
    {
      path: "/audits/4",
      component: AuditStep4,
      meta: {
        rule: "isSecretaryOnLine"
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.meta.clearStepsInformation) {
    clearStepsInformation();
  }

  if (isLogged()) {
    if (to.meta.isLogin) {
      return next({
        path: safeNext(to.query.next) || "/mailing"
      });
    } else if (
      to.meta.simulatingRegister &&
      !getStepsInformation().codAtendimento
    ) {
      return next({
        path: "/mydiary"
      });
    } else {
      return next();
    }
  } else if (to.meta.rule !== "public" && to.meta.rule !== "*") {
    // Sem sessão em rota protegida: vai pro login e volta pra cá depois.
    return next({
      path: "/login",
      query: { next: to.fullPath }
    });
  } else {
    return next();
  }
});

export default router;
